import { FieldRenderProps } from "react-final-form";
import React from "react";
import { Brush } from "@material-ui/icons";
import { Type } from "lego-gui-lib";
import { stringToColour } from "lego-gui-lib/lib/helpers/stringToColour";

export const ColorField = () =>
  new Type({
    Component: ColorFieldComponent,
    PresentationComponent: ColorFieldComponent
  });

const ColorFieldComponent = (props: FieldRenderProps<any>) => {
  const {
    input: { values }
  } = props;
  return (
    <div
      style={{
        color: "white",
        backgroundColor: stringToColour(values.name),
        textAlign: "center",
        borderRadius: "15px"
      }}
    >
      <Brush />
    </div>
  );
};
